var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10255_31918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2372 9.66024C15.1975 10.6482 16.5183 11.2062 17.8966 11.2062C20.6962 11.2062 23 8.9029 23 6.10309C23 5.81927 22.981 5.53401 22.9357 5.2624L20.3279 7.87143L17.0343 6.94128L16.1112 3.65502L18.7039 1.06215C18.4413 1.01976 18.1704 1 17.8966 1C15.0966 1 12.7931 3.30365 12.7931 6.10309C12.7931 6.49793 12.8388 6.89134 12.9293 7.2754L4.41115 15.843C4.18803 16.0664 3.90742 16.2205 3.60202 16.301C2.15585 16.6819 1 18.0604 1 19.6264C1 21.4896 2.51048 23 4.37378 23C5.95432 23 7.30383 21.8974 7.67427 20.428C7.75223 20.1183 7.90637 19.8327 8.13165 19.606L16.6369 11.0517",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10255_31918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/repair.5ba1211994ab5f2fc41c5028900012e4.svg";
export { ForwardRef as ReactComponent };